import { Box, Button, InputBase, Modal, Typography, Fade, useTheme } from '@mui/material'
import CloseIcon from 'assets/images/svg/close.svg'
import { useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import { forgotPasswordStepOne } from 'services/module/user'
import { ResponseBase } from 'services/responseBase'
import { FlexBox, LoginBox } from 'styleds'
import EmailConfirm from '../SignUp/EmailConfirm'
import InputError from 'components/InputError'
import LoadingIcon from 'components/LoadingIcon'
import { isValidEmail } from 'utils'
import { useLocation } from 'react-router-dom'

export default function ForgotPassword({ open = false, handleClose }: { open: boolean; handleClose: Function }) {
  const [email, setEmail] = useState('')
  const [step, setStep] = useState(1)
  const [error] = useState(true)
  const [message, setMessage] = useState('')
  const [count, setCount] = useState(60)
  const [loading, setLoading] = useState<boolean>(false)
  const theme = useTheme()

  const location = useLocation()

  const notIsSingleLoginPage = useMemo(() => {
    return !(location.pathname.indexOf('/login') > -1 || location.pathname.indexOf('/earlyaccess/task') > -1)
  }, [location.pathname])

  useEffect(() => {
    setEmail('')
    setMessage('')
    setLoading(false)
    setStep(1)
    setCount(60)
  }, [open])

  const submit = () => {
    if (!isValidEmail(email)) {
      setMessage('Please enter correct email format')
      return
    }
    setLoading(true)
    forgotPasswordStepOne(email).then((res: ResponseBase) => {
      if (res.code === 200) {
        toast.success(res.msg)
        if (res.data) {
          setCount(res.data)
        }
        setTimeout(() => {
          setStep(2)
        })
        setLoading(false)
      } else {
        setLoading(false)
        toast.error(res.msg)
      }
    })
  }
  return (
    <Modal open={open} closeAfterTransition>
      <Fade in={open}>
        <LoginBox>
          {notIsSingleLoginPage && (
            <img
              alt=""
              src={CloseIcon}
              onClick={() => {
                setStep(1)
                handleClose('close')
              }}
              className="close"
            />
          )}
          {step === 1 ? (
            <>
              <Typography variant="h1" component="div">
                Forgot your password?
              </Typography>
              <FlexBox marginBottom="24px">
                <Typography variant="subtitle2" color="#dddddd" component="div">
                  {`Enter the email address you used to register your account and we’ll send you instructions to reset
                    your password. For security reasons, we do not store your password. We'll never send you your password
                    via email.`}
                </Typography>
              </FlexBox>
              <InputError error={error} message={message}></InputError>
              <InputBase
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => setEmail(event.target.value)}
                value={email}
                type="email"
                placeholder="Example@email.com"
              />
              <Button
                startIcon={loading ? <LoadingIcon theme="dark" /> : ''}
                color="primary"
                onClick={submit}
                disabled={!email}
                variant="contained"
                fullWidth
                sx={{ marginTop: '1.25rem' }}
              >
                Reset Password
              </Button>
              <Box sx={{ textAlign: 'center', marginTop: '1.5rem' }}>
                <Typography
                  variant="subtitle2"
                  sx={{ cursor: 'pointer' }}
                  onClick={() => {
                    handleClose('Login')
                  }}
                  color={theme.colors.white}
                  component="span"
                >
                  Back to Log In
                </Typography>
              </Box>
            </>
          ) : (
            <EmailConfirm type="forgotPassword" email={email} count={count}></EmailConfirm>
          )}
        </LoginBox>
      </Fade>
    </Modal>
  )
}
